import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import Box from "ui/atom/Box";
import Icon from "ui/atom/Icon";
import Button from "ui/base/Button";


export default function Message({ icon, text, color, back }) {
	const theme = useTheme();

	const style = {
		root: {
			alignItems: "center",
			justifyContent: "center",
			mt: theme.spacing(5)
		}
	};

	return (
		<Box.Column gap={1} sx={style.root}>
			<Icon name={icon} size={60} color={theme.palette[color].main} />
			<Typography variant="h2" color={color}>{text}</Typography>
			{back && <Button onClick={back}>Back</Button>}
		</Box.Column>
	);
};